import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { VideoType } from "@swo/shared";
import { PDPMobileGalleryIndicator } from "./PDPMobileGalleryIndicator";
import { PDPMainImageMobileGalleryElement } from "./PDPMainImageMobileGalleryElement";
import { PDPImagesGridImageT } from "./PDP_Gallery/types";

export const PDPAboveTheFoldMainImageMobile: ReactTFC<{
  openModal: (url: string) => void;
  primaryImage: PDPImagesGridImageT;
  scrollingGalleryElements: Array<PDPImagesGridImageT | VideoType>;
  children: React.ReactNode;
}> = props => {
  const elements = [props.primaryImage, ...props.scrollingGalleryElements];
  const [visibleIdx, setVisibleIdx] = useState(0);

  const passThroughWalls = true;
  const onPrevious = () => {
    setVisibleIdx(s => (s === 0 ? (passThroughWalls ? elements.length - 1 : s) : s - 1));
  };
  const onNext = () => {
    setVisibleIdx(s => (s === elements.length - 1 ? (passThroughWalls ? 0 : s) : s + 1));
  };

  const handlers = useSwipeable({
    onSwiped: eventData => {
      if (eventData.dir === "Left") {
        return onNext();
      } else if (eventData.dir === "Right") {
        return onPrevious();
      }
    },
    preventScrollOnSwipe: true,
  });

  const elem = elements[visibleIdx]!;

  return (
    <div
      className={"js-pdp-above-the-fold-main-image--mobile"}
      css={css`
        margin-left: calc(-1 * var(--container-gutter-size));
        margin-right: calc(-1 * var(--container-gutter-size));
        width: calc(100% + 2 * var(--container-gutter-size));

        background-color: ${CSS_COLORS.GreenWhite};

        overflow-x: hidden;

        ${CSS_MQ.atLeastMd} {
          display: none;
        }
      `}
    >
      <div
        {...handlers}
        css={css`
          position: relative;
          width: 100%;

          aspect-ratio: 5/4;
        `}
      >
        <div
          css={css`
            transition: 0.3s ease-out;
            height: 100%;
          `}
          style={{
            transform: `translateX(calc(${-100 * visibleIdx}% - ${visibleIdx * 40}px))`,
          }}
        >
          {elements.map((element, i) => (
            <div
              key={JSON.stringify(element)}
              css={css`
                position: absolute;

                --g: 40px;

                width: 100%;
                height: 100%;

                top: 0;
                left: 0;

                z-index: 1;
              `}
              style={{
                transform: `translateX(calc(${100 * i}% + ${i} * var(--g)))`,
              }}
            >
              <PDPMainImageMobileGalleryElement element={elem} openModal={props.openModal} />
            </div>
          ))}
        </div>

        <PDPMobileGalleryIndicator visibleIdx={visibleIdx} elements={elements} setVisibleIdx={setVisibleIdx} />

        {props.children}
      </div>
    </div>
  );
};
